import React, { lazy } from 'react'
import { Route } from 'react-router'
import { DISPATCH_ACCESS } from '@/hooks/useDispatchAccess'
import { LoggedInRoute } from '@/router/LoggedInRoute'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Thread = lazy(() => import('./Thread'))
const Mission = lazy(() => import('./Mission'))
const Messaging = lazy(() => import('./Messaging'))
const QuickReplies = lazy(() => import('./QuickReplies'))

export const DispatchRouter = React.memo(() => (
  <SubRouter loggedIn roles={[DISPATCH_ACCESS.view]}>
    {/* Fenêtre dédiée à un fil : vue réduite à la conversation. */}
    <Route
      path='thread/:id'
      element={
        <LoggedInRoute roles={[DISPATCH_ACCESS.conversations]}>
          <Thread />
        </LoggedInRoute>
      }
    />
    {/* Page dédiée à une mission : cible des liens « éditer », ouvrables dans un onglet. Le
        segment qui suit — vol, positionnement ou conversation — est ce que la page met au point. */}
    <Route path='mission/:id/:focusKind/:focusId' element={<Mission />} />
    <Route path='mission/:id' element={<Mission />} />
    {/* Messagerie détachée par la console, synchronisée avec elle (cf. Dispatch.sync). */}
    <Route
      path='messaging'
      element={
        <LoggedInRoute roles={[DISPATCH_ACCESS.conversations]}>
          <Messaging />
        </LoggedInRoute>
      }
    />
    {/* Réponses rapides, ouvertes depuis la configuration de l'écran sans passer par les réglages. */}
    <Route
      path='quick-replies/*'
      element={
        <LoggedInRoute roles={[DISPATCH_ACCESS.conversations, DISPATCH_ACCESS.settings]}>
          <QuickReplies />
        </LoggedInRoute>
      }
    />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
